import { http } from '@/http';

export default {
    state: {
        serpPage: 1,
        serpCount: 0,
        results: [],
        resultsCount: 0,
        userName: ""
    },
    getters: {
        serpPage(state) {
            return state.serpPage;
        },
        serpCount(state) {
            return state.serpCount;
        },
        results(state) {
            return state.results;
        },
        resultsCount(state) {
            return state.resultsCount;
        },
        serpUser(state) {
            return state.userName;
        }
    },
    mutations: {
        SET_SERP_PAGE(state, payload) {
            state.serpPage = payload;
        },
        SET_SERP_COUNT(state, payload) {
            state.serpCount = payload;
        },
        SET_RESULTS(state, payload) {
            state.results = payload;
        },
        SET_RESULTS_COUNT(state, payload) {
            state.resultsCount = payload;
        },
        SET_USER_NAME(state, payload) {
            state.userName = payload;
        }
    },
    actions: {
        clearResults({ commit }) {
            commit("SET_RESULTS", []);
            commit("SET_RESULTS_COUNT", 0);
            commit("SET_SERP_COUNT", 0);
            commit("SET_SERP_PAGE", 1);
            commit("SET_USER_NAME", "");
        },
        fetchResults({ commit }, payload) {
            return http.get("/active-trader/search", {
                params: payload
            })
                .then(res => {
                    commit("SET_RESULTS", res.data.posts);
                    commit("SET_RESULTS_COUNT", res.data.posts_count);
                    commit("SET_SERP_COUNT", res.data.pages_count);
                    commit("SET_USER_NAME", res.data.user_name);
                    return res.data;
                })
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        setSerpPage({ commit }, payload) {
            commit("SET_SERP_PAGE", payload);
        }
    }
};
